import { combineReducers } from 'redux'

import { AuthRootState } from '@probatix/common/services/toolkit/auth/auth.model'
import { TestsServiceRootState } from '@probatix/common/services/toolkit/tests/testsService.model'

import { UserRootState } from '@probatix/common/services/RTKServices/patients/index.model'
import { AccountsRootState } from '@probatix/common/services/toolkit/accounts/accountsService.model'
import { OrderRootState } from '@probatix/common/services/toolkit/order/orderService.model'

import { modalServiceReducers, ModalRootState } from '@probatix/common/services/toolkit/modal'

import { authServiceReducers } from '@probatix/common/services/toolkit/auth'
import { geoLocationServiceReducers } from '@probatix/common/services/toolkit/geoLocation'

import { accountsServiceReducers } from '@probatix/common/services/toolkit/accounts'
import { orderServiceReducers } from '@probatix/common/services/toolkit/order'

import { activationApi } from '@probatix/common/services/RTKServices/activation'
import { availabilitiesApi } from '@probatix/common/services/RTKServices/availabilities'
import { patientsApi } from '@probatix/common/services/RTKServices/patients'
import { productsApi } from '@probatix/common/services/RTKServices/products'
import { orderApi } from '@probatix/common/services/RTKServices/order'
import { graphQLApi } from '@probatix/common/services/RTKServices/graphQL'
import { locationsApi } from '@probatix/common/services/RTKServices/locations'
import { patientEventsApi } from '@probatix/common/services/RTKServices/patientEvents'
import { generateDOBTokenApi } from '@probatix/common/services/RTKServices/generateDOBToken'
import { checkoutStepsApi } from '@probatix/common/services/RTKServices/checkoutSteps'
import { specimensApi } from '@probatix/common/services/RTKServices/specimens'
import { testKitsApi } from '@probatix/common/services/RTKServices/testKits'
import { testResultApi } from '@probatix/common/services/RTKServices/testResult'
import { partnersApi } from '@probatix/common/services/RTKServices/partners'
import { userObservationsApi } from '@probatix/common/services/RTKServices/userObservations'
import { testsServiceReducers } from '@probatix/common/services/toolkit/tests'
import { sessionTokenServiceReducers } from '@probatix/common/services/toolkit/sessionToken'

export interface RootState extends
  AuthRootState,
  AccountsRootState,
  ModalRootState,
  UserRootState,
  OrderRootState,
  TestsServiceRootState { }

export default combineReducers({
  accounts: accountsServiceReducers,
  auth: authServiceReducers,
  geoLocations: geoLocationServiceReducers,
  modal: modalServiceReducers,
  order: orderServiceReducers,
  sessionToken: sessionTokenServiceReducers,
  tests: testsServiceReducers,
  [activationApi.reducerPath]: activationApi.reducer,
  [availabilitiesApi.reducerPath]: availabilitiesApi.reducer,
  [checkoutStepsApi.reducerPath]: checkoutStepsApi.reducer,
  [generateDOBTokenApi.reducerPath]: generateDOBTokenApi.reducer,
  [patientsApi.reducerPath]: patientsApi.reducer,
  [patientEventsApi.reducerPath]: patientEventsApi.reducer,
  [productsApi.reducerPath]: productsApi.reducer,
  [orderApi.reducerPath]: orderApi.reducer,
  [graphQLApi.reducerPath]: graphQLApi.reducer,
  [locationsApi.reducerPath]: locationsApi.reducer,
  [specimensApi.reducerPath]: specimensApi.reducer,
  [testKitsApi.reducerPath]: testKitsApi.reducer,
  [partnersApi.reducerPath]: partnersApi.reducer,
  [testResultApi.reducerPath]: testResultApi.reducer,
  [userObservationsApi.reducerPath]: userObservationsApi.reducer,
})
